/*  ═══════════════════════════════════════════════════════════════════════════
    cart-store.js — dev-build 524–526 (Ben 20-10-2026). Loaded first, in <head>.
    1. One cart read at a time: overlapping GET /cart.js calls share one request,
       and a fresh result is reused for 400ms. Writes clear it.
    2. Every tab stays in step, straight away: after any cart write or booking
       change, a BroadcastChannel message tells the other open tabs, which run the
       existing catch-up (window.djwCatchUp, cart-reconcile.js) at once, visible or
       not. Updates caused by a message are not re-broadcast, so tabs never ping-pong.
    See CART-SYNC-AUDIT.md for the later stages.
    ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  /*  558 (Ben 21-10-2026): Back from checkout isn't always the "saved page" case 557
      catches. Often the browser re-shows the cart page from its download cache instead —
      the HTML from before you left, so the rows were the old 1-night line while the
      totals (re-fetched) were right. Any back/forward arrival on the cart page now
      reloads straight away, before anything else runs or writes. */
  (function () {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (nav.type === 'back_forward') {
      window.__djwLeaving = true;
      document.documentElement.style.visibility = 'hidden';
      location.reload();
    }
  })();
  /*  556/557 (Ben 21-10-2026): coming BACK to the cart page from checkout restores the
      page from the browser's memory, half out of date. It now reloads — and does so
      FIRST (capture phase, others stopped), because 556 reloaded while the hire-length
      check was part-way through a re-price (new line added, old not yet removed) and the
      next page "combined" them: quantity 2 became 4. Nothing may write while leaving. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && /\/cart\/?$/.test(location.pathname)) {
      e.stopImmediatePropagation();
      window.__djwLeaving = true;
      document.documentElement.style.visibility = 'hidden';
      location.reload();
    }
  }, true);
  if (window.cartStore || !window.fetch) return;
  var nativeFetch = window.fetch.bind(window), inflight = null, cached = null, cachedAt = 0, quietUntil = 0, timer = null;
  var bc = 'BroadcastChannel' in window ? new BroadcastChannel('djw-cart') : null;
  var me = Math.random().toString(36).slice(2);
  function isRead(u, o) { return /\/cart\.js(\?|$)/.test(u) && (!o || !o.method || o.method.toUpperCase() === 'GET'); }
  function isWrite(u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u); }
  var lastSig = null;
  /*  572: compare what the customer can SEE — gear, quantities, options and the booking —
      not Shopify's internal line keys or checkout's own notes. Opening checkout changes
      those, which made every tab switch show a needless skeleton. */
  var SEEN = ['Location', 'Charged nights', '_pick_up_iso', '_return_iso', 'Pick up time', 'Return time'];
  function sig(body) { try { var c = JSON.parse(body), a = c.attributes || {}; return JSON.stringify([(c.items || []).map(function (i) { return [i.variant_id, i.quantity, i.properties || {}]; }), SEEN.map(function (k) { return a[k] || ''; })]); } catch (e) { return null; } }
  var version = 0;
  /*  527: version goes up whenever the cart may have changed (a write here, a booking
      change, a message from another tab); djw:cart tells the page so ready-made copies
      (the drawer) can be prepared again. */
  function bump() { version++; if (window.cartStore) window.cartStore.version = version; document.dispatchEvent(new CustomEvent('djw:cart', { detail: { version: version } })); }
  function clear() { cached = null; cachedAt = 0; inflight = null; }
  function announce(kind, extra) {
    if (!bc || Date.now() < quietUntil) return;
    var msg = { from: me, kind: kind, t: Date.now() };
    if (extra) for (var k in extra) if (extra[k]) msg[k] = extra[k];
    try { bc.postMessage(msg); } catch (e) {}
  }
  /*  535: reads that start while a save is still on its way used to go to the network
      and come back with the OLD cart. They now wait for the save and are answered from
      what it returns (or, after an add, with one fresh read). */
  var pending = 0, waitQ = [];
  /*  536: a hire-length change is a save, then remove the old line, then add the new
      one. Each step announced "cart changed", so the drawer refreshed in between and
      showed the old price, then an empty cart, then the right one. Now the page hears
      "busy" when the first write starts (skeletons go on) and "changed" once, 300ms
      after the LAST write of the burst finishes. Other tabs hear it then too. */
  var settle = null, busy = false;
  /*  540: a date change is ONE change to the customer, even when it takes a save then a
      re-price. Busy now starts the moment the dates are picked (so availability, nights,
      prices and total skeleton together) and "changed" is only announced once every
      line's hire length matches the new nights — never on the in-between cart. */
  var bookingHold = 0;
  function startBusy() { clearTimeout(hardStop); hardStop = setTimeout(function () { bookingHold = 0; pending = 0; var q = waitQ; waitQ = []; q.forEach(function (f) { f(); }); if (busy) release(); }, 12000); if (!busy) { announce('busy'); busy = true; document.documentElement.classList.add('djw-cart-busy'); document.dispatchEvent(new CustomEvent('djw:cart-busy')); } }
  /*  541: the bar also fires bookingbar:changed when it only re-syncs (opening the drawer,
      loading a page) — no save follows, so busy never ended and the drawer froze in its
      skeleton. Busy now ends on its own if no save starts within 1.5s, and can never
      last longer than 12s whatever happens. */
  var idleCheck = null, hardStop = null;
  document.addEventListener('bookingbar:changed', function () {
    /* 547: a bar re-syncing from another tab's change is not a change made here. */
    if (isSyncing() || remoteBusy) return;
    bookingHold = Date.now(); startBusy();
    clearTimeout(idleCheck);
    idleCheck = setTimeout(function () { if (!pending && !upQ && busy) finish(); }, 1500);
  });
  function finish() {
    if (bookingHold) {
      var cartNow = null; try { cartNow = cached ? JSON.parse(cached) : null; } catch (e) {}
      var ok = function (c) { return !c || consistent(c) || Date.now() - bookingHold > 8000; };
      var go = function (c) {
        if (pending) return;
        if (!ok(c)) { clearTimeout(settle); settle = setTimeout(function () { if (!pending) window.fetch('/cart.js').then(function (r) { return r.json(); }).then(go, function () { go(null); }); }, 700); return; }
        bookingHold = 0; release();
      };
      return cartNow ? go(cartNow) : window.fetch('/cart.js').then(function (r) { return r.json(); }).then(go, function () { go(null); });
    }
    release();
  }
  /*  552: "finished" now carries the finished cart and the drawer already drawn (from the
      re-price's last request), so other tabs show them without fetching anything. */
  function release() { var dh = window.__djwNextDrawerHtml || null, ct = cached; clearTimeout(hardStop); clearTimeout(idleCheck); busy = false; document.documentElement.classList.remove('djw-cart-busy'); bump(); announce('cart', { cart: ct, drawer: dh }); }
  function hold(p) {
    startBusy();
    clearTimeout(settle); pending++;
    return p.then(function (x) { done(); return x; }, function (e) { done(); throw e; });
  }
  function done() {
    pending = Math.max(0, pending - 1);
    if (pending) return;
    var q = waitQ; waitQ = []; q.forEach(function (f) { f(); });
    clearTimeout(settle);
    settle = setTimeout(function () { if (!pending) finish(); }, 300);
  }
  /*  561 — ONE WRITER, ONE LOCK. Every change to the cart goes through exclusive(),
      which holds the browser's own cross-tab lock (navigator.locks): only one tab can
      change the cart at a time, and a multi-step change (the re-price) holds it for
      all of its steps. Other tabs wait their turn instead of colliding. Inside a held
      lock, further writes from this tab run straight through. Older browsers without
      locks fall back to a same-tab queue. */
  var locks = (navigator.locks && navigator.locks.request) ? navigator.locks : null;
  var lockDepth = 0, localChain = Promise.resolve();
  function exclusive(fn) {
    if (lockDepth > 0) return Promise.resolve().then(fn);
    var run = function () { lockDepth++; return Promise.resolve().then(fn).finally(function () { lockDepth--; }); };
    if (locks) return locks.request('djw-cart-write', run);
    var p = localChain.then(run, run); localChain = p.catch(function () {}); return p;
  }
  function fresh() { return nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (t) { cached = t; cachedAt = Date.now(); lastSig = sig(t) || lastSig; return JSON.parse(t); }); }
  var prodCache = {};
  var rcT = null;
  var remoteBusy = false, rbT = null, syncUntil = 0;
  function isSyncing() { return Date.now() < syncUntil; }
  var upQ = null;
  function queueUpdate(body, opts) {
    if (!upQ) {
      upQ = { attributes: {}, note: undefined, waiters: [], headers: opts.headers };
      var release; hold(new Promise(function (r) { release = r; })); upQ.release = function () { release(); };
      setTimeout(function () {
        var q = upQ; upQ = null;
        var send = {}; if (Object.keys(q.attributes).length) send.attributes = q.attributes; if (q.note !== undefined) send.note = q.note;
        clear();
        exclusive(function () { return nativeFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: q.headers || { 'Content-Type': 'application/json' }, body: JSON.stringify(send) }); })
          .then(function (r) { return r.text().then(function (t) { clear(); if (r.ok) { cached = t; cachedAt = Date.now(); lastSig = sig(t) || lastSig; } q.waiters.forEach(function (w) { w.ok(new Response(t, { status: r.status, headers: { 'Content-Type': 'application/json' } })); }); q.release(); }); })
          .catch(function (e) { q.release(); q.waiters.forEach(function (w) { w.no(e); }); });
      }, 120);
    }
    Object.assign(upQ.attributes, body.attributes || {});
    if (body.note !== undefined) upQ.note = body.note;
    return new Promise(function (ok, no) { upQ.waiters.push({ ok: ok, no: no }); });
  }
  window.fetch = function (input, opts) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    /*  539 (stage 3b): a product's variant list (/products/<handle>.js) was fetched by
        the product page AND the hire-length check for the same change. It's now fetched
        once and kept for 5 minutes, shared by every caller. Prices and variants don't
        change mid-visit; a reload always starts fresh. */
    var pm = u.match(/\/products\/([^\/?#]+)\.js(\?|$)/);
    if (pm && (!opts || !opts.method || opts.method.toUpperCase() === 'GET')) {
      var hit = prodCache[pm[1]];
      if (!hit || Date.now() - hit.at > 300000) {
        hit = prodCache[pm[1]] = { at: Date.now(), p: nativeFetch(input, opts).then(function (r) { return r.text().then(function (t) { if (!r.ok) delete prodCache[pm[1]]; return { t: t, s: r.status }; }); }, function (e) { delete prodCache[pm[1]]; throw e; }) };
      }
      return hit.p.then(function (x) { return new Response(x.t, { status: x.s, headers: { 'Content-Type': 'application/json' } }); });
    }
    if (isRead(u, opts) && pending) {
      return new Promise(function (ok) { waitQ.push(ok); }).then(function () { return window.fetch(input, opts); });
    }
    if (isRead(u, opts)) {
      /*  532: a cart this tab just wrote (or just read) is reused for 3s, not 400ms —
          the cart.js read straight after the merged save was asking for what the save had
          already returned. */
      if (cached && Date.now() - cachedAt < 3000) return Promise.resolve(new Response(cached, { status: 200, headers: { 'Content-Type': 'application/json' } }));
      if (!inflight) {
        inflight = nativeFetch(input, opts).then(function (r) { return r.text().then(function (body) { if (r.ok) { cached = body; cachedAt = Date.now(); lastSig = sig(body) || lastSig; } inflight = null; return { body: body, status: r.status }; }); }, function (e) { inflight = null; throw e; });
      }
      return inflight.then(function (x) { return new Response(x.body, { status: x.status, headers: { 'Content-Type': 'application/json' } }); });
    }
    /*  531 (stage 3): booking details were saved two or three times for one change —
        booking-bar.js, charged-nights.js and booking-calendar.js each post their own
        /cart/update.js a few milliseconds apart. Attribute-only updates arriving within
        120ms are now merged into ONE request (later values win), and every caller gets
        the same answer back. Updates that change line quantities are sent as they are. */
    if (/\/cart\/update(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string') {
      var parsed = null; try { parsed = JSON.parse(opts.body); } catch (e) {}
      if (parsed && !parsed.updates && Object.keys(parsed).every(function (k) { return k === 'attributes' || k === 'note'; })) {
        return queueUpdate(parsed, opts);
      }
    }
    if (isWrite(u)) {
      clear();
      return hold(exclusive(function () { return nativeFetch(input, opts); }).then(function (r) {
        clear();
        if (!r.ok) return r;
        /*  534: /cart/change.js and /cart/update.js answer with the whole cart, so it is
            kept as the shared copy and the read after them is answered from it. (add.js
            answers with the added line only, so after an add the next read still goes out.) */
        return r.clone().text().then(function (t) {
          if (/\/cart\/(change|update)/.test(u) && /"token"\s*:/.test(t) && /"items"\s*:/.test(t)) { cached = t; cachedAt = Date.now(); lastSig = sig(t) || lastSig; }
          return r;
        }, function () { return r; });
      }));
    }
    return nativeFetch(input, opts);
  };
  /*  525: a booking change is announced by the cart writes it causes (attributes, re-priced
      lines), after they finish — never on its own, or the other tab re-priced at the same
      moment and the item was added twice. */
  /*  533: a booking change is not itself a cart change — the save it causes is. Clearing
      here dropped the read already on its way, so two reads went out back to back, and
      djw:cart fired before the save, so the drawer refreshed once too early. The save's
      own completion now does both. */
  if (bc) bc.onmessage = function (e) {
    var m = e.data || {}; if (m.from === me) return;
    /*  547: two tabs re-priced the same line (quantity 2, then skeletons on a loop).
        The tab making a change now says "busy" when it starts; other tabs skeleton,
        write nothing and don't catch up until it says "changed". While they refresh
        from that, their own booking-bar resync doesn't count as a change. */
    if (m.kind === 'busy') {
      remoteBusy = true; clearTimeout(rbT); rbT = setTimeout(function () { remoteBusy = false; document.documentElement.classList.remove('djw-remote-busy', 'djw-catchup'); if (!busy) document.documentElement.classList.remove('djw-cart-busy'); }, 12000);
      document.documentElement.classList.add('djw-cart-busy', 'djw-remote-busy');
      return;
    }
    /*  548: the skeleton used to come off the moment "changed" arrived, then go back on
        when the refresh started ~0.5s later — showing the old cart in between (Ben: "flashes
        the old dates, price, nights and total"). It now stays on, unbroken, until the
        refresh has drawn the new cart. */
    /*  549: 548 kept djw-cart-busy on through the refresh — but the drawer refresh waits
        for busy to clear, so it waited for ever. Busy comes off as before; the skeleton
        stays on its own class until the refresh is done (6s at most, whatever happens). */
    remoteBusy = false; clearTimeout(rbT);
    if (!busy) document.documentElement.classList.remove('djw-cart-busy');
    document.documentElement.classList.add('djw-remote-busy');
    var got = !!m.cart;
    if (got) { clear(); cached = m.cart; cachedAt = Date.now(); lastSig = sig(m.cart) || lastSig; }
    if (m.drawer) window.__djwNextDrawerHtml = m.drawer;
    clearTimeout(rcT); rcT = setTimeout(function () { document.documentElement.classList.remove('djw-remote-busy', 'djw-catchup'); }, 6000);
    if (!got) clear(); bump();
    quietUntil = Date.now() + 2500;
    clearTimeout(timer);
    /*  525: the other tab only REFRESHES what it shows. It never re-prices or writes —
        the tab where the change was made already did that. Waits for the last message
        in a burst (a re-price is a remove then an add). */
    timer = setTimeout(async function () {
      if (!got) clear();
      /*  554: the cart page no longer reloads when another tab changes the booking. It
          refreshes its lines, totals, bond, times and delivery estimate in place — the
          same re-render the cart page already uses for its own date changes — so typed
          text, ticked boxes and scroll position stay put. An empty cart still reloads
          (the empty page needs its scripts). */
      var onCartPage = /\/cart\/?$/.test(location.pathname), cartNow = null;
      if (onCartPage) {
        try { cartNow = cached ? JSON.parse(cached) : null; } catch (e) {}
        if (!cartNow) { try { cartNow = await window.fetch('/cart.js').then(function (r) { return r.json(); }); } catch (e) {} }
        if (!cartNow || !cartNow.item_count || !(window.BookingRow && window.BookingRow.refreshSections)) { location.reload(); return; }
        var a = cartNow.attributes || {};
        if (window.pbCartBookings) Object.assign(window.pbCartBookings, { location: a['Location'] || '', locationSuburb: a['Location suburb'] || '', pickUp: a['Pick up'] || '', pickUpTime: a['Pick up time'] || '', 'return': a['Return'] || '', returnTime: a['Return time'] || '', chargedNights: a['Charged nights'] || '', pickUpIso: a['_pick_up_iso'] || '', returnIso: a['_return_iso'] || '' });
      }
      var html = document.documentElement; html.classList.add('djw-catchup');
      var call = async function (n) { var f = window[n]; if (typeof f === 'function') { try { await f(); } catch (err) {} } };
      try {
        syncUntil = Date.now() + 60000;
        /*  550: these ran one after another (~3s in tab B). The bar goes first (the rest
            read its dates); then the drawer, the Already-added box, the count and the
            option prices all refresh at once, and the skeleton comes off when the bar
            and drawer are done — the slower product-page parts follow on their own. */
        await call('bbSyncFromCart');
        if (onCartPage) { try { await Promise.resolve(window.BookingRow.refreshSections()); } catch (err) { location.reload(); return; } }
        var rest = Promise.all([call('djwRefreshBooked'), call('djwRefreshCount'), call('ppbRepriceOptions')]).then(function () { return call('updateCTAState'); });
        await call('refreshCartDrawerIfOpen');
        html.classList.remove('djw-remote-busy'); clearTimeout(rcT);
        await rest;
      } finally { html.classList.remove('djw-catchup', 'djw-remote-busy'); clearTimeout(rcT); syncUntil = Date.now() + 1500; }
    }, 60);
  };
  /*  526: coming back to a tab used to run the full catch-up (with the price skeleton)
      every time, even when nothing had changed — left over from 520, before tabs were
      updated in the background. Now one quick cart read decides: same cart as this tab
      last saw, nothing happens; different, the catch-up runs as before. This listener
      is registered before cart-reconcile.js's, so it can stop that one. */
  document.addEventListener('visibilitychange', function (e) {
    if (document.visibilityState !== 'visible' || window.__djwVisPass) return;
    if (remoteBusy) { e.stopImmediatePropagation(); return; }
    e.stopImmediatePropagation();
    var before = lastSig;
    clear();
    window.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (body) {
      var now = sig(body);
      if (before && now && now === before) return;
      if (typeof window.djwCatchUp === 'function') window.djwCatchUp('tab');
      else { window.__djwVisPass = true; document.dispatchEvent(new Event('visibilitychange')); window.__djwVisPass = false; }
    }).catch(function () {});
  });
  /*  538: true when every line's hire period matches the booking's charged nights.
      After a date change the dates save first and the lines are re-priced a moment
      later — anything drawn in between shows a price for the wrong hire length ($80 for
      a week). Surfaces wait (skeleton on) until this is true. */
  function fits(n, label) {
    var l = (label || '').toLowerCase().trim(), m;
    if ((m = l.match(/^(\d+)\s+night/))) return n === +m[1];
    if ((m = l.match(/^(\d+)\s*-\s*(\d+)\s+night/))) return n >= +m[1] && n <= +m[2];
    if (l.indexOf('week') > -1) return n >= 4 && n <= 7;
    if (l.indexOf('month') > -1) return n >= 8;
    return true;
  }
  function consistent(cart) {
    var n = parseInt(((cart && cart.attributes) || {})['Charged nights'], 10);
    if (!cart || !(n > 0)) return true;
    return (cart.items || []).every(function (it) {
      var o = (it.options_with_values || []).find(function (x) { var k = (x.name || '').toLowerCase(); return k.indexOf('hire') > -1 || k.indexOf('period') > -1; });
      return !o || fits(n, o.value);
    });
  }
  window.cartStore = { exclusive: exclusive, fresh: fresh, clear: clear, announce: announce, version: version, consistent: consistent, syncing: isSyncing,
    /*  551: a date change is now announced the moment the re-price finishes (or straight
        away when nothing needed re-pricing), instead of polling the cart every ~1s. */
    holding: function () { return !!bookingHold; },
    settleWith: function (c) {
      if (!busy || pending) return;
      clearTimeout(settle);
      if (c && c.items) { try { cached = JSON.stringify(c); } catch (e) {} } else clear();
      finish();
    }, remoteBusy: function () { return remoteBusy; } };
})();
